export const DESCRIPTION_SHARE_FRIENDS =
  'Olá! Quer ficar livre das tarifas bancárias pra sempre e ganhar cashback em todas as suas compras? Baixe o Super App do Inter e abra sua conta digital 100% gratuita. 🤩 Já abri a minha e indico! https://bancointer.onelink.me/eiWM/t75svlz8'

export const TWO_SECONDS = 2000

export const MEI_ACCOUNT_TERMS =
  'https://s3.sa-east-1.amazonaws.com/static.bancointer.com.br/conta-digital-pf/condicoes_cdpj_novo.pdf'
